import template from './aliButton.template.html';
import templateRefer from './ali.template.html';

export default {
  template,
  bindings: {
    contacts: '<',
    ticketClientTypes: '<',
    loanAmount: '<',
    ownerName: '<',
    idTicket: '<',
    aliId: '<',
    aliEmail: '<',
    appAliId: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($mdDialog, $mdMedia, helperService, aliService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;

      ctrl.initialize = () => {
        ctrl.contacts = ctrl.contacts || [];
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.loanAmount = ctrl.loanAmount || 0;
        ctrl.ownerName = ctrl.ownerName || '';
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.aliId = ctrl.aliId || '';
        ctrl.aliEmail = ctrl.aliEmail || '';
        ctrl.appAliId = ctrl.appAliId || '';
        ctrl.isDisabled = ctrl.isDisabled || false;
      };

      ctrl.openDialog = ($event) => {
        $event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {
              contacts: ctrl.contacts || [],
              idTicket: ctrl.idTicket || '',
              ticketClientTypes: ctrl.ticketClientTypes || [],
              ownerName: ctrl.ownerName || '',
              aliId: ctrl.aliId || '',
              aliEmail: ctrl.aliEmail || '',
              loanAmount: ctrl.loanAmount || 0,
              appAliId: ctrl.appAliId || ''
            },
            template: templateRefer,
            controllerAs: '$ctrl',
            multiple: true,
            controller(
              contacts,
              idTicket,
              ticketClientTypes,
              ownerName,
              aliId,
              aliEmail,
              loanAmount,
              appAliId
            ) {
              const self = this;
              self.contacts = contacts;
              self.idTicket = idTicket;
              self.ticketClientTypes = ticketClientTypes;
              self.ownerName = ownerName;
              self.aliId = aliId;
              self.aliEmail = aliEmail;
              self.loanAmount = loanAmount;
              self.appAliId = appAliId;
              self.filteredContacts = _.filter(
                self.contacts,
                (c) =>
                  !c.isCompany &&
                  !helperService.isClientServicingGuarantor({
                    ticketClientTypes: self.ticketClientTypes,
                    idContact: c.id
                  }) &&
                  !helperService.isClientSecurityGuarantor({
                    ticketClientTypes: self.ticketClientTypes,
                    idContact: c.id
                  })
              );
              self.selectedClients = self.filteredContacts.slice(0, 2);
              self.errorMessages = [];
              self.hasError = false;
              self.isLoading = null;
              self.url = '';
              self.result = false;

              self.confirm = () => {
                window.open(self.url, '_blank');
                $mdDialog.hide(self.result);
              };

              self.refer = () => {
                self.errorMessages = [];
                self.hasError = false;
                self.isLoading = true;
                aliService
                  .refer({
                    idTicket: self.idTicket,
                    idClients: _.map(self.selectedClients, 'id')
                  })
                  .then((result) => {
                    self.isLoading = false;
                    if (result?.status) {
                      self.url = result.url;
                      self.result = true;
                    } else {
                      self.hasError = true;
                      if (result?.errors?.length) {
                        const len = result?.errors?.length || 0;
                        for (let e = 0; e < len; e += 1) {
                          const error = result?.errors[e];
                          const message = error?.label
                            ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                            : error?.message || error || '';
                          self.errorMessages.push(message);
                        }
                      } else {
                        self.errorMessages.push(result?.errorMessage);
                      }
                      self.errorMessages.unshift('ALI errors:');
                    }
                  });
              };

              self.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            ctrl.onFinished({ status: result });
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
